import React, {useEffect, useState} from 'react'
import VideoCard from 'components/VideoCard'
import VideoList from 'components/VideoList'
import styles from "../style/components/concertVideo.module.css"
import axios from 'axios'

const ConcertVideos = () => {
  const [videos, setVideos] = useState([])

	useEffect(() => {
    const getVideos = async () => {
      try {
        const res = await axios.get("https://rishat-tour.ru/api/videos")
        setVideos(res.data)
      } catch (error) {
        console.log(error.message)
      }
    }
    getVideos()
  }, [])
	return (
		<div className={styles.container}>
			<div className={styles.concertVideosWrapper}>
				<div className={styles.concertVideosTitle}>
					<p>Концертные видео</p>
					<VideoList videos={videos}/>
				</div>
			</div>
		</div>
	)
}


export default ConcertVideos